import React from 'react';
import {connect, useSelector} from 'react-redux';
import {dwhBanReport, DwhActionType, DWHMessageText, DWHStatus} from '../../reports/dwhReports';

import BanStatusHeader from './BanStatusHeader';
import PaidBanStatus from './PaidBanStatus';
import PaymentInProcessBanStatus from './PaymentInProcessBanStatus';
import DebtBanStatus from './DebtBanStatus';
import PaymentIssueBanStatus from './PaymentIssueBanStatus';
import ScheduledPaymentBanStatus from './ScheduledPaymentBanStatus';
import {BanTypeEnum} from '../../Constants/banTypeEnum';
import {stepEnum} from '../../Constants/debtPaymentEnum';
import {handleBanData, handleCurrentStep} from '../../DebtAndUpdatePaymentBlockSlice';
import './banStatuses.scss';

const BanStatusCard = ({
  banData,
  getPaymentStatusesForBan,
  isActiveJetBan,
  bitPaymentOption,
  yDaysCount,
  paymentConfiguration,
  dispatch,
}) => {
  const loginData = useSelector((state) => state.authentication.loginData);

  const onActionClick = (actionType) => {
    switch (actionType) {
      case 'payment':
        dwhBanReport({
          banData,
          loginData,
          actionType: DwhActionType.AccountListPage,
          messageText: DWHMessageText.DebtClicked,
          status: DWHStatus.Ongoing,
          yDaysCount,
          yDaysCountEnergy: yDaysCount,
        });
        dispatch(handleBanData(banData));
        if (bitPaymentOption) {
          getPaymentStatusesForBan(banData);
        } else {
          dispatch(handleCurrentStep(stepEnum.SELECTAMOUNT));
        }
        break;
      default:
        break;
    }
  };

  const handlePaymentClick = () => onActionClick('payment');

  const banType = banData?.banType;
  const renderStatusContent = () => {
    switch (banType) {
      case BanTypeEnum.BAN_WITH_DEBT:
      case BanTypeEnum.BAN_WITH_DEBT_ABOVE_MAX:
        return (
          <DebtBanStatus banData={banData} onActionClick={banType === BanTypeEnum.BAN_WITH_DEBT_ABOVE_MAX ? null : handlePaymentClick} />
        );

      case BanTypeEnum.BAN_NO_DEBT_BUT_HAD_DEBT_IN_INVOICE:
        return <PaymentInProcessBanStatus banData={banData} />;

      case BanTypeEnum.BAN_WITHOUT_PAYMENT_METHOD:
        return (
          <PaymentIssueBanStatus
            banData={banData}
            onPaymentClick={handlePaymentClick}
            yDaysCount={yDaysCount}
            paymentConfiguration={paymentConfiguration}
          />
        );

      case BanTypeEnum.BAN_WITH_FUTURE_INVOICE:
      case BanTypeEnum.BAN_WITH_BALANCE_FOR_CHARGING:
        return <ScheduledPaymentBanStatus banData={banData} onActionClick={handlePaymentClick} />;

      case BanTypeEnum.BAN_NO_DEBT_NO_PREVIOUS_DEBT:
        return <PaidBanStatus banData={banData} yDaysCount={yDaysCount} />;

      default:
        return null;
    }
  };

  return (
    <div className={`ban-status-card ${isActiveJetBan ? 'jet-active-ban' : ''}`}>
      <BanStatusHeader ban={banData} />
      {/* <>{banData.banType}</> */}
      <div className='ban-status-content'>{renderStatusContent()}</div>
    </div>
  );
};

const mapStateToProps = (state, ownProps) => {
  const isEnergy = ownProps.banData?.isEnergy;
  const du = state.debtAndUpdatePayment;
  return {
    bitPaymentOption: du.bitPaymentOption,
    yDaysCount: isEnergy ? du.energyPaymentStatusDisplayDaysY : du.paymentStatusDisplayDaysY,
    paymentConfiguration: {
      paymentStatusDisplayDaysX: du.paymentStatusDisplayDaysX,
      paymentStatusDisplayDaysY: du.paymentStatusDisplayDaysY,
      energyPaymentStatusDisplayDaysX: du.energyPaymentStatusDisplayDaysX,
      energyPaymentStatusDisplayDaysY: du.energyPaymentStatusDisplayDaysY,
    },
  };
};

export default connect(mapStateToProps)(BanStatusCard);
